// Google Analytics Configuration
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics 4 Measurement ID
export const ANALYTICS_CONFIG = {
  GA_MEASUREMENT_ID: 'G-Y2KF5JXJ9C', // TODO: Replace with your actual GA4 ID
  
  // Cookie settings
  COOKIE_DOMAIN: 'auto', // or specify your domain like '.yourdomain.com'
  COOKIE_EXPIRES: 365, // days
  
  // Privacy settings
  ANONYMIZE_IP: true,
  ALLOW_GOOGLE_SIGNALS: false,
  ALLOW_AD_PERSONALIZATION: false,
  
  // Debug mode (set to false in production)
  DEBUG_MODE: process.env.NODE_ENV === 'development'
};

// GDPR/Privacy compliance settings
export const PRIVACY_CONFIG = {
  // Show consent banner to all users or only EU users
  SHOW_TO_ALL_USERS: true,
  
  // Auto-reject after X days if no interaction
  AUTO_REJECT_DAYS: null, // Set to number of days or null to disable
  
  // Consent banner texts (you can customize these)
  TEXTS: {
    BANNER_TITLE: 'Szanujemy Twoją prywatność',
    BANNER_DESCRIPTION: 'Używamy plików cookie i podobnych technologii, aby zapewnić najlepsze doświadczenia na naszej stronie internetowej.',
    ACCEPT_ALL: 'Zaakceptuj wszystkie',
    REJECT_ALL: 'Odrzuć wszystkie',
    CUSTOMIZE: 'Dostosuj ustawienia',
    SAVE_PREFERENCES: 'Zapisz preferencje'
  }
};
